import React from 'react';
import { Modal, Grid, IconButton, Box, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { CaseMilestone } from 'pages/Cases/hooks/useGetCases';

interface ErrorDeleteMilestoneModalProps {
  open: boolean;
  handleClose: () => void;
  milestoneError: any;
  milestone: CaseMilestone;
}

const ErrorDeleteMilestoneModal: React.FC<ErrorDeleteMilestoneModalProps> = ({
  open,
  handleClose,
  milestoneError,
  milestone,
}) => {
  const errorMessage: string = milestoneError?.error ?? '';
  const relatedActionIds: string = milestoneError?.relatedActions ?? '';

  const idMatch = errorMessage.match(/with id (.*?) because/);
  const actionId = idMatch ? idMatch[1].trim() : '';
  const action = milestone.actions.find(action => action.id === actionId);

  const actionName = action?.versionName || 'Milestone Action';
  const dependencyNames = relatedActionIds || 'Milestone dependencies';
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={open}
      onClose={handleClose}
      sx={{
        display: 'flex',
        p: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={theme => ({
          position: 'relative',
          width: 700,
          bgcolor: '#fff',
          boxShadow: theme.shadows[5],
          borderRadius: '4px',
        })}
      >
        <Box sx={{ padding: '16px' }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                }}
              >
                Error - {actionName}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ backgroundColor: '#F7F7F7', padding: '16px' }}>
          <Box
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '23px',
                letterSpacing: '0%',
                textAlign: 'center',
              }}
            >
              You cannot delete <b>{actionName}</b> because it was used to
              generate <b>{dependencyNames}</b>.
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '23px',
                letterSpacing: '0%',
                textAlign: 'center',
              }}
            >
              <br /> Please delete <b>{dependencyNames}</b> first.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ErrorDeleteMilestoneModal;
